// Dynamic imports
const Login = () => import('@/views/auth/Login.vue')
const Signup = () => import('@/views/auth/Signup.vue')
const ForgotPassword = () => import('@/views/auth/ForgotPassword.vue')
const ResetPassword = () => import('@/views/auth/ResetPassword.vue')
const EmailConfirmation = () => import('@/views/auth/EmailConfirmation.vue')
const AuthCallback = () => import('@/views/auth/AuthCallback.vue')
const AcceptInvite = () => import('@/views/auth/AcceptInvite.vue')

export const authRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: {
      title: 'Sign Up'
    }
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: AuthCallback,
    meta: {
      title: 'Authentication'
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      title: 'Forgot Password'
    }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      title: 'Reset Password'
    }
  },
  {
    path: '/email-confirmation',
    name: 'EmailConfirmation',
    component: EmailConfirmation,
    meta: {
      title: 'Email Confirmation'
    }
  },
  {
    path: '/accept-invite',
    name: 'AcceptInvite',
    component: AcceptInvite,
    meta: {
      title: 'Accept Invite'
    }
  }
]
